import styled from "styled-components";
import {styledByDevice} from "../../../../themes/architecture/styled-by-device";

const PaymentRedirectFocusDefaultBox = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    font-size: 1.5rem;
    font-family: ${({theme}) => theme.font.family.body};
    margin: 2.5rem 0 2.5rem 0;
    padding: 0 2rem 0 2rem;
`;

const PcBox = styled(PaymentRedirectFocusDefaultBox)`
    width: 29vw;
`;

const MobileBox = styled(PaymentRedirectFocusDefaultBox)`
    width: 90vw;
    @media ${({theme}) => `${theme.mediaQuery.landscape}`} {
        width: 60vw;
    }
`;


export const PaymentRedirectFocusBox = styledByDevice(PcBox, MobileBox);